/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForJiraServiceManagementIncidentManagement extends models.GovernanceConfigurationBaseForJiraServiceManagement {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForJiraServiceManagementIncidentManagement");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForJiraServiceManagementIncidentManagement.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForJiraServiceManagementIncidentManagement>): GovernanceConfigurationForJiraServiceManagementIncidentManagement {
        let obj = Object.assign(new GovernanceConfigurationForJiraServiceManagementIncidentManagement(), model);
        GovernanceConfigurationForJiraServiceManagementIncidentManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForJiraServiceManagementIncidentManagement>): GovernanceConfigurationForJiraServiceManagementIncidentManagement {
        if (!model) return null;
        return GovernanceConfigurationForJiraServiceManagementIncidentManagement.newInstance(<GovernanceConfigurationForJiraServiceManagementIncidentManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForJiraServiceManagementIncidentManagement) {
        if (!obj) return;

        models.GovernanceConfigurationForJiraServiceManagementIncidentManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForJiraServiceManagementIncidentManagement): boolean {
        if (models.GovernanceConfigurationBaseForJiraServiceManagement.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForJiraServiceManagementIncidentManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.alerts_mapping) {
            models.JiraServiceManagementAlertsMapping.fixupPrototype(this.alerts_mapping);
        }
        if (this.budget_alerts_mapping) {
            models.JiraServiceManagementBudgetAlertsMapping.fixupPrototype(this.budget_alerts_mapping);
        }
        if (this.security_alerts_mapping) {
            models.JiraServiceManagementSecurityAlertMapping.fixupPrototype(this.security_alerts_mapping);
        }
        if (this.policy_alerts_mapping) {
            models.JiraServiceManagementPolicyMapping.fixupPrototype(this.policy_alerts_mapping);
        }
    }

    /**
     * Email Address for Requester
     */
    requester_email: string;

    /**
     * Attribute mapping for Jira Service Management Alerts
     */
    alerts_mapping: models.JiraServiceManagementAlertsMapping;

    /**
     * Attribute mapping for Jira Service Management Budget Alerts
     */
    budget_alerts_mapping: models.JiraServiceManagementBudgetAlertsMapping;

    /**
     * Attribute mapping for Jira Service Management Security Alerts
     */
    security_alerts_mapping: models.JiraServiceManagementSecurityAlertMapping;

    /**
     * Attribute mapping for Jira Service Management Policy Alerts
     */
    policy_alerts_mapping: models.JiraServiceManagementPolicyMapping;

}
